const FALLBACK_MESSAGE = "Something went wrong. Please try again.";

/**
 * Reads the error body of a failed notes request. The body is `{ error, field }`.
 * `message` is the server text, or a generic text when the body has none.
 * `field` is the name of the input at fault, or null when no input is at fault.
 */
export const readNoteApiError = (e) => {
  const body = e?.response?.data;
  const message = typeof body?.error === "string" && body.error.trim() ? body.error : FALLBACK_MESSAGE;
  const field = typeof body?.field === "string" && body.field ? body.field : null;
  return { message, field };
};
